export default __webpack_public_path__ + "static/logo2-a05f3850819ea6c06f2dee1fd83869ce.png";